module.exports = {"430528100":"金石镇","430528101":"水庙镇","430528102":"崀山镇","430528104":"黄龙镇","430528105":"高桥镇","430528106":"回龙寺镇","430528107":"一渡水镇","430528108":"马头桥镇","430528200":"黄金瑶族乡","430528201":"麻林瑶族乡","430528203":"万塘乡","430528204":"清江桥乡","430528205":"安山乡","430528206":"丰田乡","430528208":"巡田乡","430528209":"靖位乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430528.json
// module id = 1981
// module chunks = 0